/**
 * <pre>
 * Navigation config.
 *
 * Summary of responsibilities:
 *
 *  - Keeps track of which modules are hidden/visible.
 * </pre>
 *
 * @author Clay Kirk
 *
 * @memberof module:Navigation
 * @namespace
 *
 * @type {Object}
 */
const Config = {
  stateKey: 'navigation',
};

export default Config;
